export class ChatUser {
  id: number = -1;
  name: string = "";
  username: string = "";

  constructor(init?: Partial<ChatUser>) {
    Object.assign(this, init);
  }
}